import { userMixin } from "../user/userMixin";
import { token } from "./token";
import { login } from "../../services/api";

export const authMixin = {
  mixins: [userMixin, token],
  methods: {
    async login(username, password) {
      const res = await login({ username, password });
      if (!(res instanceof Error)) {
        const access_token = res.data.access_token;
        this.setAccessToken(access_token);
        this.fetchAndUpdateUser();
      } else return res;
    },
    async logout() {
      this.revokeAccessToken();
      this.logoutUser();
    }
  }
};
